import { useTranslation } from "react-i18next";
import Layout from "./common/Layout";
import Back from "./common/Back";
import {
  useAppSelector,
  useApi,
  useAppDispatch,
  useCompany,
  useEmail,
  useFirstName,
  useLastName,
  useDateOfBirth,
} from "../store/hooks";
import { getMainIdentifier, getPrimaryPostCode } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { GoToTheNextStep } from "./Step";
import Spinner from "./common/Spinner";

const Summary = () => {
  const { t, i18n } = useTranslation();
  const { getWorkflow } = useApi();
  const email = useEmail();
  const firstName = useFirstName();
  const lastName = useLastName();
  const dateOfBirth = useDateOfBirth();
  const company = useCompany();
  const postCode = getPrimaryPostCode(company.addresse?.postCodes);
  const { patchOnboarding } = useApi();
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formatDateOfBirth = (date) => {
    if (!date) return "";

    // Si la date est au format DD/MM/YYYY, la convertir en YYYY-MM-DD
    let dateStr = date;
    if (date.includes("/")) {
      const [day, month, year] = date.split("/");
      dateStr = `${year}-${month}-${day}`;
    }

    const dateObj = new Date(dateStr);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return dateObj.toLocaleDateString(i18n.language, options);
  };

  const handleClick = async () => {
    try {
      setIsProcessing(true);
      await patchOnboarding({ isLegalAgreementAccepted: true });
      await GoToTheNextStep(navigate, dispatch, getWorkflow);
    } catch (error) {
      console.log("summary error", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Layout>
      <div className="az-title">{t("summary.title")}</div>

      <div className="az-subtitle">{t("summary.subtitle")}</div>

      <div className="summary-container">
        <div className="summary-section">
          <img
            src={process.env.PUBLIC_URL + "images/person.svg"}
            alt="person-icon"
          />
          <span className="icon-span">{t("summary.identifiedAs")}</span>
          {firstName && lastName && (
            <p className="mt-2">
              {firstName} {lastName}
              {dateOfBirth && (
                <>
                  {" "}
                  ({t("summary.born")} {formatDateOfBirth(dateOfBirth)})
                </>
              )}
            </p>
          )}
          <p className="bold">{email}</p>
        </div>

        <div className="summary-section">
          <img
            src={process.env.PUBLIC_URL + "images/company_s.svg"}
            alt="company-icon"
          />
          <span className="icon-span">{t("summary.selectedCompany")}</span>
          <p className="bold mt-2">{company.name}</p>
          <div>
            {company.addresse?.streetNumber &&
              `${company.addresse?.streetNumber} `}
            {company.addresse?.streetName}
            {company.addresse?.streetName && ", "}
            {postCode} {company.addresse?.city}
          </div>
          <p>
            {company.idTypeCode} - {company.idValue}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <input
          onChange={(e) => setIsAgreementAccepted(e.target.checked)}
          checked={isAgreementAccepted}
          type="checkbox"
          name="agreement"
          id="agreement"
        />
        <label className="agreement-label" htmlFor="agreement">
          {t("summary.gdpr")}
        </label>
      </div>

      <div
        className={`az-btn text-uppercase mt-5 ${!isAgreementAccepted || isProcessing ? "disabled" : ""}`}
        onClick={handleClick}
        tabIndex={0}
        role="button"
      >
        {isProcessing ? <Spinner size={24} /> : t("summary.btn.label")}
      </div>

      <Back message={t("back.label")} />
    </Layout>
  );
};

export default Summary;
